class DropdownFilter {
  constructor(args = {}) {
    this.options = Object.assign({
      el: $('.dropdown'),
      list: $('.dropdown-list'),
      current: $('.dropdown-current'),
      filterTarget: null,
    }, args);

    this.currentFilter = null;
    this.init();
  }

  init() {
    // Toggle dropdown
    this.options.current.on('click', () => this.toggleDropdown());

    // Set choice
    $('li', this.options.list).on('click', (event) => {
      this.toggleDropdown();
      this.replaceCurrentValue(event);
      this.doFilter();
    });
  }

  toggleDropdown() {
    this.options.list.toggleClass('toggled');
  }

  replaceCurrentValue(event) {
    const value = $(event.currentTarget).data('filter');
    const text = event.currentTarget.innerHTML;

    this.options.current.html(text);
    this.currentFilter = value;
  }

  doFilter() {
    // Filter has been reset
    if (this.currentFilter === '*') {
      $('[data-filter]').removeClass('filter-hidden filter-visible');
      return;
    }

    // Set all data filters to 'hidden'
    $('[data-filter]', this.options.filterTarget)
      .removeClass('filter-visible')
      .addClass('filter-hidden');

    // Now set the matching results to 'visible'
    $(`[data-filter=${this.currentFilter}]`, this.options.filterTarget)
      .removeClass('filter-hidden')
      .addClass('filter-visible');
  }
}

export default DropdownFilter;
